import { createActionWithPayload } from './utils';

export const ACTIONS = {
  UPDATE_PERFECT_HIT: 'UPDATE_PERFECT_HIT',
} as const;

export const updatePerfectHit = createActionWithPayload<
  typeof ACTIONS.UPDATE_PERFECT_HIT,
  {
    studentClassroomId: string;
    perfectHits: number;
  }
>(ACTIONS.UPDATE_PERFECT_HIT);
